import { applyCCDiscount } from "@src/utilities/general";
import { state, ui } from "../../../../interfaces/interfaces";
import { billingMiddleware } from "./billing/index";
import { customerMiddleware } from "./customer";
import { paymentMiddleware } from "./payment/index";
import { planDetailsMiddleware } from "./planDetails";

export const serviceAgreementMiddleware = async (action: { payload: { name: string; value: any } }, next: any) => {
  switch (action.payload.name) {
    case "CarePlanCustomerAddressAsContact":
    case "CarePlanCustomerAddressAsProperty":
    case "CarePlanCustomerAddressProperty":
    case "CarePlanCustomerAddressCity":
    case "CarePlanCustomerAddressLocality":
    case "CarePlanCustomerAddressBusinessName":
    case "CarePlanCustomerAddressPostcode":
    case "CarePlanCustomerAddressStreet":
    case "CarePlanCustomerContactEmail":
    case "CarePlanCustomerContactFirstName":
    case "CarePlanCustomerContactLandline":
    case "CarePlanCustomerContactLastName":
    case "CarePlanCustomerContactMobile":
    case "CarePlanCustomerContactTitle":
      customerMiddleware(action, next);
      break;

    case "CarePlanPlanDetailsAddressAsProperty":
    case "CarePlanPlanDetailsAddressProperty":
    case "CarePlanPlanDetailsAddressCity":
    case "CarePlanPlanDetailsAddressLocality":
    case "CarePlanPlanDetailsAddressBusinessName":
    case "CarePlanPlanDetailsAddressPostcode":
    case "CarePlanPlanDetailsAddressStreet":
    case "CarePlanPlanDetailsBoilerBoilerInstallationDate":
    case "CarePlanPlanDetailsBoilerBoilerLastServicedDate":
    case "CarePlanPlanDetailsBoilerBoilerManufacturers":
    case "CarePlanPlanDetailsBoilerBoilerModel":
    case "CarePlanPlanDetailsBoilerGasSafetyDueDate":
    case "CarePlanPlanDetailsBoilerHeatingTypes":
    case "CarePlanPlanDetailsOfferOfferReason":
    case "CarePlanPlanDetailsOfferOfferType":
    case "CarePlanPlanDetailsOfferPromoCode":
    case "CarePlanPlanDetailsPlanOptionsBillingFrequencies":
    case "CarePlanPlanDetailsPlanOptionsBillingFrequency":
    case "CarePlanPlanDetailsPlanOptionsDuration":
    case "CarePlanPlanDetailsPlanOptionsExcess":
    case "CarePlanPlanDetailsPlanOptionsPlanType":
    case "CarePlanPlanDetailsPlanOptionsComments":
    case "CarePlanPlanDetailsPropertyBathrooms":
    case "CarePlanPlanDetailsPropertyBedrooms":
    case "CarePlanPlanDetailsPropertyBuildingTypes":
    case "CarePlanPlanDetailsPropertyComments":
    case "CarePlanPlanDetailsPropertyExclusionDetails":
    case "CarePlanPlanDetailsPropertyExternalDoors":
    case "CarePlanPlanDetailsPropertyGasAppliances":
    case "CarePlanPlanDetailsPropertyRadiators":
      planDetailsMiddleware(action, next);
      break;

    case "CarePlanBillingAddressAsProperty":
    case "CarePlanBillingAddressProperty":
    case "CarePlanBillingAddressCity":
    case "CarePlanBillingAddressLocality":
    case "CarePlanBillingAddressBusinessName":
    case "CarePlanBillingAddressPostcode":
    case "CarePlanBillingAddressStreet":
    case "CarePlanBillingContactAsContact":
    case "CarePlanBillingContactEmail":
    case "CarePlanBillingContactFirstName":
    case "CarePlanBillingContactLandline":
    case "CarePlanBillingContactLastName":
    case "CarePlanBillingContactMobile":
    case "CarePlanBillingContactTitle":
    case "CarePlanBillingMethodPaymentType":
      billingMiddleware(action, next);
      break;

    case "CarePlanPaymentBankDetailsAccountNumber":
    case "CarePlanPaymentBankDetailsBankBranchName":
    case "CarePlanPaymentBankDetailsSortCode":
      paymentMiddleware(action, next);
      break;

    case "CarePlanOffered":
      if (action.payload.value) {
        state.JobHaveOfferedServiceAgreement = true;
      } else {
        state.JobHaveOfferedServiceAgreement = false;
      }
      ui.CarePlanDeclinedReason = null;

      return next(action);

    case "CarePlanReference":
      applyCCDiscount(action.payload.value);
      return next(action);

    case "CarePlanDeclinedReason":
      state.JobServiceAgreementDeclinedId = action.payload.value?.serviceAgreementDeclinedId
        ? action.payload.value?.serviceAgreementDeclinedId
        : 0;
      if (action.payload.value?.serviceAgreementDeclinedId === 4) state.JobHaveOfferedServiceAgreement = false;
      else state.JobHaveOfferedServiceAgreement = true;
      return next(action);

    default:
      return next(action);
  }
};
